import { GetUserQuery } from "types/graphql/graphql";
import type { NotificationData, NotificationTargetRoute } from "../types";
import { NotificationScreen } from "../types";

export const getNotificationUrl = (
  data: NotificationData,
  language: string,
  userRoles: GetUserQuery["user"]["userRoles"],
): string | null => {
  const target = data.meta?.target as NotificationTargetRoute | undefined;

  if (!target) {
    return null;
  }

  const {
    app,
    screen,
    taskId,
    companyId,
    employmentId,
    productAssignmentId,
    requestId,
    role,
  } = target;
  if (app === "admin") {
    if (screen === NotificationScreen.tasks && taskId) {
      if (companyId) {
        return `/${language}/admin/companies/${companyId}/tasks/${taskId}/overview`;
      } else if (role === "company") {
        const userRole = userRoles.find(
          (userRole) => userRole.company !== null,
        );
        const companyId = userRole?.company?.id;
        return `/${language}/admin/companies/${companyId}/tasks/${taskId}/overview`;
      }
      return `/${language}/admin/tasks/${taskId}/overview`;
    }

    if (screen) {
      if (companyId) {
        return `/${language}/admin/companies/${companyId}/${screen}`;
      }
      return `/${language}/admin/${screen}`;
    }

    if (companyId) {
      return `/${language}/admin/companies/${companyId}/dashboard/overview`;
    }

    return null;
  }

  if (app === "employee") {
    if (screen === NotificationScreen.kycRequest && requestId) {
      if (employmentId && productAssignmentId) {
        return `/${language}/employee/employment/${employmentId}/${productAssignmentId}/kyc-request/${requestId}`;
      }

      return `/${language}/employee/kyc-request/${requestId}`;
    }
    if (screen === NotificationScreen.employmentDetails) {
      return `/${language}/employee/settings/employment-details`;
    }

    if (screen) {
      if (employmentId && productAssignmentId) {
        const basePath = `/${language}/employee/employment/${employmentId}/${productAssignmentId}/${screen}`;
        return taskId ? `${basePath}/${taskId}` : basePath;
      }

      if (employmentId) {
        const basePath = `/${language}/employee/employment/${employmentId}/${screen}`;
        return taskId ? `${basePath}/${taskId}` : basePath;
      }

      const basePath = `/${language}/employee/${screen}`;
      return taskId ? `${basePath}/${taskId}` : basePath;
    }

    return null;
  }
  return null;
};
